import React from "react";
import { Link } from "react-router-dom";
import { useTranslation } from "react-i18next";
import logo1 from "../../../../assets/images/Logos/m2logo-1.png";
import logo2 from "../../../../assets/images/Logos/m-squared-Automation-IT-infra-logo.png";
import logo3 from "../../../../assets/images/Logos/dental-logo.png";
import logo4 from "../../../../assets/images/Logos/800cad_logo.jpg";
import logo5 from "../../../../assets/images/Logos/TOC_logo.jpg";
import logo6 from "../../../../assets/images/Logos/las.png";
function LogoDiv() {
  const { t } = useTranslation();
  return (
    <>
      <div className="logo-head">{t("Our Business")}</div>
      <div className="logo">
        <Link to={`https://m2india.com/`} target="_blank">
          <img src={logo1} />
        </Link>
        <Link to={`https://m2infotek.com/`} target="_blank">
          <img src={logo2} />
        </Link>
        <Link to={`https://800cad.com/`} target="_blank">
          <img src={logo4} id="img4" />
        </Link>
        <Link to={`https://www.las-travels.com/`} target="_blank">
          <img src={logo6} />
        </Link>
        <Link to={`https://dentalatm2.com/`} target="_blank">
          <img src={logo5} />
        </Link>
        <Link to={`https://dentalatm2.com/`} target="_blank">
          <img src={logo3} />
        </Link>
      </div>
    </>
  );
}

export default LogoDiv;
